var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 428.31226,
    height: 447.83478,
    viewBox: "0 0 428.31225 447.83477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(290.23437 0 0 -290.23437 157.654 273.073)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#00b9f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#005bab"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.751 275.666c-59.945.008-127.985 21.883-145.097 75.109 0-13.976.62-39.033 1.706-53.182 6.293-82.049 81.85-112.648 143.358-112.666h.067c61.504.018 145.104 35.453 145.104 112.666 0 14.19-.042 49.646-.042 63.625-17.112-53.23-85.149-85.544-145.096-85.552"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 -210.205 694.404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.751 275.666c-59.945.008-127.985 21.883-145.097 75.109 0-13.976.62-39.033 1.706-53.182 6.293-82.049 81.85-112.648 143.358-112.666h.067c61.504.018 145.104 35.453 145.104 112.666 0 14.19-.042 49.646-.042 63.625-17.112-53.23-85.149-85.544-145.096-85.552",
    style: {
      fill: "url(#b)",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-17.976 6.355-39.5 10.589-60.318 10.632v.01c-.062 0-.125-.004-.185-.004s-.123.004-.183.004v-.01c-82.26-.154-140.77-55.647-140.77-130.602 0-7.423.594-14.534 1.707-21.347 23.826 49.911 80.264 69.879 139.246 69.93 20.535-.014 41.262-2.742 60.393-8.616z",
    style: {
      fill: "#98cb4f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 278.758 14.19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-5.747-14.828-7.271-44.358-7.271-44.358s26.442 18.77 72.262 15.272c43.911-3.343 88.488-38.197 88.488-38.197V1.481S119.86 35.01 63.866 36.422C31.329 37.24 8.178 21.113 0 0",
    style: {
      fill: "#faa634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 223.674 205.38)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/경북교육청.1170b0e4a7a5def69e7cf8021e3cd47f.svg";
export { ForwardRef as ReactComponent };